import React from "react";
import { FormattedMessage } from "react-intl";

export const genDailyMessage = model => (
	model.request_pending ? <FormattedMessage id="Request pending" />
		: model.data.length ? null : <FormattedMessage id="No Data" />
);
